import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'answer-search',
    name: 'client-answer-search',
    component: () => import('./AnswerLookup.vue'),
    meta: {
      permissions: [Permission.ClientsSuppliersView],
    },
  },
] satisfies RouteRecordRaw[];
